<div style="margin-top: 10px;">
  <form [formGroup]="serviceForm">
    <mat-card class="no_box_shadow">
      <mat-card-content>
        <div class="example-button-row">
          <span class="__filter_icon" style="background-color: white;"></span>

          @if (addPermission) {
            <a class="__add_client" (click)="openForm()">
              <mat-icon class="__icon">add_circle</mat-icon>
              Create Service
            </a>
          }
        </div>

        <mat-divider></mat-divider>
        @if (viewPermission) {
          <div class="table-scroll-container">
          <table mat-table [dataSource]="dataSource" class="mat-elevation-z0">
            <ng-container matColumnDef="serviceCode">
              <th mat-header-cell *matHeaderCellDef class="header">
                Service Code
              </th>
              <td mat-cell *matCellDef="let row">{{ row.serviceCode }}</td>
            </ng-container>
            <ng-container matColumnDef="serviceDescription">
              <th mat-header-cell *matHeaderCellDef>
                <div class="sorting_header">
                  <span>Service Description</span>
                  <div class="search-input-wrapper">
                    <input matInput type="search" autocomplete="off"
                      placeholder="Search by Service Description" formControlName="serviceDescription"
                      class="mat-input-custom" />
                      <!-- <span class="clear-search" *ngIf="serviceForm.get('serviceDescription')?.value"
                      (click)="clearServiceDescriptionSearch()">
                      ✕
                    </span> -->
                  </div>
                </div>
              </th>
              <td mat-cell *matCellDef="let row">
                {{ row.serviceDescription }}
              </td>
            </ng-container>
            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef class="header">
                Action
              </th>
              <td mat-cell *matCellDef="let row">
                <span class="__action_edit_icon" (click)="openForm(row)">
                  <mat-icon>create</mat-icon>
                </span>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"
            [ngClass]="{'duplicate-row': isDuplicateRow(row)}"></tr>
          </table>
          </div>
        }
      </mat-card-content>
    </mat-card>
    @if (viewPermission) {
      <mat-paginator [pageSizeOptions]="pageSizeOptions" [length]="totalServiceRecords"
        showFirstLastButtons>
      </mat-paginator>
    }

  </form>
</div>